import { render, staticRenderFns } from "./AdminToyBox.vue?vue&type=template&id=3dac7a68"
import script from "./AdminToyBox.vue?vue&type=script&lang=js"
export * from "./AdminToyBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports